import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowRight, Loader2 } from "lucide-react";
import { toast } from "sonner";
import Seo from "@/components/Seo";
import Logo from "@/components/shared/Logo";
import { adminLogin, formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await adminLogin(email, password);
      localStorage.setItem("cb_admin_token", data.access_token);
      localStorage.setItem("cb_admin_user", JSON.stringify(data.user));
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] px-6">
      <Seo title="Admin Login" description="CompuBrain AI admin." path="/admin/login" />
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-8"><Logo /></div>
        <div className="rounded-2xl border border-gray-200 bg-white p-8">
          <div className="h-11 w-11 rounded-xl bg-[#0B63F6]/[0.08] flex items-center justify-center text-[#0B63F6] mb-5"><Lock className="h-5 w-5" /></div>
          <h1 className="font-display text-2xl font-bold tracking-tight">Admin sign in</h1>
          <p className="text-sm text-gray-500 mt-1">Access the leads dashboard.</p>
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="admin-login-form">
            <input className="w-full border border-gray-200 rounded-xl px-4 py-3 text-[15px] focus:outline-none focus:border-[#0B63F6]" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" />
            <input className="w-full border border-gray-200 rounded-xl px-4 py-3 text-[15px] focus:outline-none focus:border-[#0B63F6]" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
            <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full inline-flex items-center justify-center gap-2 bg-[#111111] text-white rounded-full px-7 py-3.5 font-medium hover:bg-[#0B63F6] transition-colors disabled:opacity-60">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Sign in <ArrowRight className="h-4 w-4" /></>}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
